export default __webpack_public_path__ + "static/media/icon-copy.d8af112f.svg";